import { createContext } from 'react'

/**
 * @description Context for extended firebase instance created
 * by react-redux-firebase
 */
const ReduxFirestoreContext = createContext(null)

export default ReduxFirestoreContext



// WEBPACK FOOTER //
// ../src/ReduxFirestoreContext.js